var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var defaultState = {
    scenarioFiles: { list: [], loading: false, error: false },
    selectedScenarioId: '',
};
export function scenarioStateReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case 'SCENARIO_FILES_LOADING':
            return __assign({}, state, { scenarioFiles: { list: state.scenarioFiles.list, error: false, loading: true } });
        case 'SCENARIO_FILES_LOAD_FAILED':
            return __assign({}, state, { scenarioFiles: { list: [], error: action.message, loading: false } });
        case 'SCENARIO_FILES_LOADED':
            return __assign({}, state, { scenarioFiles: { list: action.list, loading: false, error: false } });
        case 'SCENARIO_SELECTION_CHANGED':
            return __assign({}, state, { selectedScenarioId: action.selectedScenarioFileName });
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/containers/TestController/reducers.ts
// module id = 1832
// module chunks = 0